import PropTypes from "prop-types";
import React, { Component } from "react";
import { ListItem } from "material-ui/List";
import DatePicker from "components/form/date-picker";
import ChevronIcon from "material-ui/svg-icons/navigation/chevron-left";
import moment from "moment";
import Globalize from "globalize";
import theme from "styles/theme";
import Badge from "material-ui/Badge";
import Bottom from "./bottom";
import Spacer from "./spacer";
import { toDataTest } from "helpers/test";

type DateFilterProps = {
    filter: any;
    activeFiltersValues: any;
    onChange: (value: any, field: string) => void;
    field: string;
    hintText: string;
    onFocus?: (e: any) => void;
    onDismiss?: (e: any) => void;
};
const AVAILABILITY_START_DATE_GTE = "__availability_start_date_gte";
const AVAILABILITY_END_DATE_LTE = "__availability_end_date_lte";
class DateFilter extends Component<DateFilterProps> {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
        hintText: PropTypes.string.isRequired,
        onFocus: PropTypes.func,
        onDismiss: PropTypes.func,
    };

    state: {
        fieldKey: string;
    };

    constructor(props: DateFilterProps) {
        super(props);
        this.state = {
            fieldKey: props.filter[props.field],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    styles = {
        clearIcon: {
            top: "0px",
        },
    };

    handleChange(e: object, date: Date): void {
        const { activeFiltersValues, onChange, field } = this.props;
        const { fieldKey } = this.state;
        const momentDate = moment.utc(moment(date).format("MM/DD/YYYY"), "MM/DD/YYYY"); // convert to utc
        if (field === "__max_key") {
            momentDate.endOf("day");
        }
        onChange(
            date ? activeFiltersValues.set(fieldKey, momentDate.valueOf()) : activeFiltersValues.delete(fieldKey),
            field,
        );
    }

    render() {
        const { filter, activeFiltersValues, field, hintText } = this.props;
        const { fieldKey } = this.state;
        const timestamp = activeFiltersValues.get(fieldKey);
        const minDateForMaxKey = activeFiltersValues.get(AVAILABILITY_START_DATE_GTE);
        const value = timestamp ? moment.utc(Number(timestamp)) : undefined;
        let minDate;
        if (filter.__min_date) {
            const minTime =
                fieldKey === AVAILABILITY_END_DATE_LTE
                    ? minDateForMaxKey || filter.__min_date.valueOf()
                    : filter.__min_date.valueOf();
            minDate = moment.utc(minTime);
        }
        return (
            <DatePicker
                autoOk={true}
                value={value}
                dataTest={field + "-" + toDataTest(field)}
                onChange={this.handleChange}
                hintText={hintText}
                onFocus={this.props.onFocus ? this.props.onFocus : undefined}
                onDismiss={this.props.onDismiss ? this.props.onDismiss : undefined}
                style={{
                    display: "block",
                    margin: "0 18px 0 16px",
                }}
                dialogContainerStyle={{
                    zIndex: 3000,
                }}
                clearable={true}
                clearStyle={this.styles.clearIcon}
                minDate={minDate}
                maxDate={filter.__max_date ? moment.utc(filter.__max_date.valueOf()) : null}
                name={`datepicker-${field}`}
            />
        );
    }
}

type Props = {
    filter: any;
    activeFiltersValues: any;
    onChange: (values: any) => void;
    onFocus?: (e: any) => void;
    onDismiss?: (e: any) => void;
    lastFilter: boolean;
};

class DateFilters extends Component<Props> {
    state: {
        open: boolean;
    };

    static contextTypes = {
        muiTheme: PropTypes.object,
    };

    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        lastFilter: PropTypes.bool,
    };

    static defaultProps = {
        lastFilter: false,
    };

    styles = {
        nestedListItem: {
            backgroundColor: "transparent",
        },
        listItem: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
        },
        shortListItemInner: {
            padding: "10px 0px 10px 8px",
        },
        longListItemInner: {
            width: "92%",
            padding: "10px 0px 10px 8px",
        },
        dropdownIcon: {
            top: -6,
        },
        longDropdownIcon: {
            marginRight: "-6px",
            marginTop: "5px",
        },
        longDropdownIconWithBadge: {
            top: "-6px",
            margin: "12px",
            right: "-13px",
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
        shortBadge: {
            top: 6,
            right: 44,
            color: theme.palette.darkerGrey,
            backgroundColor: theme.palette.lightGrey,
        },
        longBadge: {
            top: 6,
            right: 44,
            marginRight: "-18px",
            color: theme.palette.darkerGrey,
            backgroundColor: theme.palette.lightGrey,
        },
        badgeContainer: {
            position: "static",
            padding: "0px",
        },
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
        };

        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { filter, activeFiltersValues } = this.props;
        if (activeFiltersValues.get(filter.__min_key) || activeFiltersValues.get(filter.__max_key)) {
            this.setState({
                open: true,
            });
        }
    }

    // TODO: rewrite this mess
    handleChange(values, field): void {
        const { onChange, filter } = this.props;
        if (filter.__default_date_range) {
            const minValue = values.get(filter.__min_key);
            const maxValue = values.get(filter.__max_key);
            if (field === "__min_key") {
                if (minValue) {
                    if (!maxValue) {
                        let max = moment.utc(minValue).add(filter.__default_date_range, "days");
                        max = moment.min(max, filter.__max_date ? moment.utc(filter.__max_date) : max);
                        values = values.set(filter.__max_key, max.valueOf());
                    } else {
                        // NOTE: to set date for max_key if maxValue is before start day.
                        const maxDate = moment.utc(maxValue);
                        if (maxDate.isBefore(minValue)) {
                            values = values.set(filter.__max_key, minValue);
                        }
                    }
                } else {
                    // clear max value out
                    if (maxValue) {
                        values = values.delete(filter.__max_key);
                    }
                }
            } else {
                if (maxValue) {
                    if (!minValue) {
                        let newDate = moment.utc(maxValue).subtract(filter.__default_date_range, "days");
                        if (filter.__min_date && newDate.isBefore(filter.__min_date)) {
                            newDate = filter.__min_date;
                        }
                        values = values.set(filter.__min_key, newDate.valueOf());
                    }
                } else {
                    // clear min value out
                    if (minValue) {
                        values = values.delete(filter.__min_key);
                    }
                }
            }
        }
        onChange(values);
    }

    handleToggleOpen() {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { filter, activeFiltersValues, lastFilter, onFocus, onDismiss } = this.props;
        const { open } = this.state;
        const styles = this.styles;
        const items = [
            <DateFilter
                key="min"
                field="__min_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
                onFocus={onFocus ? onFocus : undefined}
                onDismiss={onDismiss ? onDismiss : undefined}
                hintText={Globalize.formatMessage("Earliest Date")}
            />,
            <Spacer key="spacer" />,
            <DateFilter
                key="max"
                field="__max_key"
                activeFiltersValues={activeFiltersValues}
                filter={filter}
                onChange={this.handleChange}
                onFocus={onFocus ? onFocus : undefined}
                onDismiss={onDismiss ? onDismiss : undefined}
                hintText={Globalize.formatMessage("Latest Date")}
            />,
        ];

        if (!lastFilter) {
            items.push(<Bottom key="bottom" />);
        }

        let title = filter.__name;
        let count = 0;
        const MAX_LINE_LENGTH = 25;
        let chevronIconStyle, listItemInnerDivStyle, badgeStyle;

        if (title.length > MAX_LINE_LENGTH) {
            chevronIconStyle = count === 0 ? styles.longDropdownIcon : styles.longDropdownIconWithBadge;
            listItemInnerDivStyle = styles.longListItemInner;
            badgeStyle = styles.longBadge;
        } else {
            chevronIconStyle = styles.dropdownIcon;
            listItemInnerDivStyle = styles.shortListItemInner;
            badgeStyle = styles.shortBadge;
        }

        ["__min_key", "__max_key"].forEach((key) => {
            if (activeFiltersValues.get(filter[key])) {
                count = count + 1;
            }
        });
        if (count > 0) {
            title = (
                <Badge
                    badgeContent={count}
                    primary={true}
                    // @ts-ignore
                    style={styles.badgeContainer}
                    badgeStyle={badgeStyle}
                >
                    {filter.__name}
                </Badge>
            );
        }

        return (
            <ListItem
                primaryText={title}
                initiallyOpen={open}
                style={styles.listItem}
                nestedItems={items}
                primaryTogglesNestedList={true}
                innerDivStyle={listItemInnerDivStyle}
                nestedListStyle={styles.nestedListItem}
                onNestedListToggle={this.handleToggleOpen}
                rightIcon={
                    <ChevronIcon
                        style={Object.assign({}, chevronIconStyle, open && styles.dropdownIconOpen)}
                        data-test={`chevron-${toDataTest(filter.__key)}`}
                    />
                }
            />
        );
    }
}

export const FilterInput = DateFilter;

export default DateFilters;
